import React from "react";
import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import ChaosHeader from "@/components/ChaosHeader";
import AppFooter from "@/components/AppFooter";
import UpdatesPanel from "@/components/UpdatesPanel";

const UpdatesPage = () => (
  <div
    data-testid="updates-page"
    className="chaos-grain chaos-bg-gradient min-h-[100dvh] w-full text-[#f1f5f9]"
  >
    <ChaosHeader showCredits />
    <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-6 lg:py-10">
      <Link
        to="/"
        data-testid="updates-back-link"
        className="inline-flex items-center gap-1.5 font-mono text-[11px] sm:text-xs uppercase tracking-[0.22em] text-[#cbd5e1] hover:text-[#FF0033] transition-colors mb-4"
      >
        <ChevronLeft size={13} />
        Back to Terminal
      </Link>
      <UpdatesPanel variant="page" />
    </main>
    <AppFooter />
  </div>
);

export default UpdatesPage;
